
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jak-to-dziala",
      function () {
        return require("private-next-pages/jak-to-dziala/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jak-to-dziala"])
      });
    }
  